module.exports = __webpack_public_path__ + "img/xiaochengxu.0418bde7.png";